/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#videoWrap[_ngcontent-%COMP%]{\n\tposition: fixed;\n\tleft:0;\n\ttop:0;\n\tright:0;\n\tbottom:0;\n  \t-webkit-transform-origin: top right;\n  \t        transform-origin: top right;\n}\n\n#videoHover[_ngcontent-%COMP%]{\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  z-index: 10000;\n  position: fixed;\n}\n\n#videoShortCut[_ngcontent-%COMP%]{\n\tdisplay: none;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    top: 0;\n    width: 100%;\n    position: absolute;\n    z-index: 9999;\n}\n\n#video-auth[_ngcontent-%COMP%]{\n\t-webkit-transform-origin: top right;\n\t        transform-origin: top right;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-video/case-practice-authorization-video.component.css.shim.ngstyle.js.pre-build-optimizer.js